import type { ConfirmOptions, ConnectionConfig } from "@solana/web3.js";
import { clusterApiUrl } from "@solana/web3.js";

type NetworkConfig = ConnectionConfig & {
  name: string;
  endpoint: string;
};

export const CONFIRM_OPTIONS: ConfirmOptions = {
  preflightCommitment: "confirmed",
  commitment: "confirmed",
};

export const getStepConnectionConfig = (authorizationRequired: boolean): ConnectionConfig => {
  const defaultConfig: ConnectionConfig = {
    commitment: "recent",
  };

  if (authorizationRequired && process.env.REACT_APP_DEFAULT_ENDPOINT_AUTHORIZATION_HEADER) {
    return {
      ...defaultConfig,
      httpHeaders: {
        Authorization: process.env.REACT_APP_DEFAULT_ENDPOINT_AUTHORIZATION_HEADER,
      },
    };
  }

  return defaultConfig;
};

export const STEP_NETWORK_CONFIG_MAP: { [network: string]: NetworkConfig } = {
  "mainnet-beta": {
    name: "Mainnet Beta",
    endpoint: process.env.REACT_APP_MAINNET_BETA_ENDPOINT_URL || "https://step.rpcpool.com/",
    ...getStepConnectionConfig(true),
  },
  devnet: {
    name: "Devnet",
    endpoint: process.env.REACT_APP_DEVNET_ENDPOINT_URL || clusterApiUrl("devnet"),
    ...getStepConnectionConfig(false),
  },
  testnet: {
    name: "Testnet",
    endpoint: process.env.REACT_APP_TESTNET_ENDPOINT_URL || clusterApiUrl("testnet"),
    ...getStepConnectionConfig(false),
  },
} as const;
